import { mergeQueryKeys } from '@lukemorales/query-key-factory'

import { assistant } from 'src/features/assistant/queries'
import { leads } from 'src/features/business/leads/queries'
import { notes } from 'src/features/business/notes/queries'
import { referrals } from 'src/features/business/referrals/queries/referral-queries'
import { referralShares } from 'src/features/business/referrals/queries/share-queries'
import { business } from 'src/features/business/shared/queries'
import { chats } from 'src/features/chats/queries'
import { network } from 'src/features/chats/sub-features/network/queries'
import { partnerMatch } from 'src/features/chats/sub-features/partner-match/queries'
import { feeds } from 'src/features/feeds/queries/feed-queries'
import { globalActivity } from 'src/features/global-activity/queries'
import { invites } from 'src/features/invites/queries/invite-queries'
import { notifications } from 'src/features/notifications/queries/queries'
import { search } from 'src/features/search/queries/search'
import { auth } from 'src/shared/features/auth/queries/queries'
import { consumers } from 'src/shared/features/consumers/queries'
import { enterprise } from 'src/shared/features/enterprise/queries'
import { listings } from 'src/shared/features/listing/queries'
import { users } from 'src/shared/features/users/queries/user-queries'

export const queries = mergeQueryKeys(
  auth,
  notifications,
  referrals,
  referralShares,
  users,
  feeds,
  invites,
  chats,
  partnerMatch,
  network,
  assistant,
  consumers,
  globalActivity,
  notes,
  leads,
  business,
  enterprise,
  search,
  listings,
)
